module.exports = __webpack_public_path__ + "static/media/bio-pic.e7037936.jpg";